import { useOrderStore } from "@/src/store/useOrderStore";
import { reportApi } from "@/src/utils/api/report";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FilterDays from "./FilterDays";
import Icons from "@/src/components/Icons";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";
import ChartPenalty from "./ChartPenalty";

function ReportPenalty() {
  const { setOrder, setRoute } = useOrderStore();
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);

  const [data, setData] = useState<any>([]);
  const [from, setFrom] = useState<number>(startOfToday.getTime());
  const [to, setTo] = useState<number>(endOfToday.getTime());
  const [totalSum, setTotalSum] = useState<number>(0);
  const [showFilter, setShowFilter] = useState<string>("امروز");
  let history = useNavigate();

  useEffect(() => {
    reportApi.penalty(from, to).then((res) => {
      setData(res.data);

      if (res.data && res.data.list && res.data.list.length > 0) {
        const totalPenaltyAmount = res.data.list.reduce(
          (acc: any, item: any) => acc + (parseInt(item.price) || 0),
          0
        );
        setTotalSum(totalPenaltyAmount);
      } else {
        setTotalSum(0);
      }
    });
  }, [from, to]);
  
  return (
    <div>
      <h4
        className="title text-xl font-extrabold flex items-center cursor-pointer"
        onClick={() => history("/report")}
      >
        <Icons name="arrowBack" fill="none" size={40} />
        خطا و جریمه
      </h4>
      <FilterDays
        setFrom={setFrom}
        setTo={setTo}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
      />
      <div className="shadow-mmpz border border-gray-100-mmpz p-3 mt-4 rounded-xl">
        {data && data.list && data.list.length > 0 ? (
          <div className="flex flex-col gap-3  pb-4">
            <div className="totalSell flex justify-between items-center">
              <p className="mb-0 font-bold text-xl">جمع مبلغ جریمه‌ها:</p>
              <span>
                {digitsEnToFa(addCommas(totalSum))}{" "}
                <small className="text-xs text-gray-200-mmpz">تومان</small>
              </span>
            </div>
            <div className="totalSell flex justify-between items-center">
              <p className="mb-0  ">تعداد:</p>
              <span>
                {data &&
                  data.total &&
                  digitsEnToFa(
                    data.total.hairCount +
                      data.total.discrepancyCount +
                      data.total.etcCount
                  )}{" "}
                <small className="text-xs text-gray-200-mmpz">عدد</small>
              </span>
            </div>
            <hr className="text-gray-100-mmpz" />
            <ChartPenalty dataProps={data.total} />
          </div>
        ) : (
          <div className="flex flex-col gap-3 pb-4">
            <div className="items  mt-2 flex flex-col justify-center items-center">
              <Icons name="undefinedIcon" size={200} fill="none" />
              <h6 className="text-xl font-bold text-gray-200-mmpz">
                خطایی برای شما ثبت نشده است.
              </h6>
            </div>
          </div>
        )}
      </div>
      <div className="table w-full mt-4">
        <div className="header flex items-center justify-between  p-2 py-3 shadow-mmpz">
          <div className="w-1/4 text-sm">ردیف</div>
          <div className="w-1/4 text-sm">روز و تاریخ</div>
          <div className="w-1/4 text-sm ps-2">
            مبلغ <span className="text-xs text-gray-200-mmpz ">(تومان)</span>
          </div>
          <div className="w-1/4 text-sm text-end">جزئیات</div>
        </div>
        <div className="body">
          {data &&
            data.list &&
            data.list.length > 0 &&
            data.list.map((item: any, index: number) => {
              return (
                <div
                  className="item flex items-center justify-between p-2 py-4 border-b border-b-gray-100-mmpz"
                  onClick={() => {
                    setOrder(item);
                    setRoute("penalty");
                    history("/report/order/details");
                  }}
                >
                  <div className="w-1/4">{digitsEnToFa(index + 1)}</div>
                  <div className="w-1/4 text-sm text-gray-200-mmpz text-c">
                    {" "}
                    <p className="text-center w-fit">
                      {" "}
                      {digitsEnToFa(moment(item.date).format("jYYYY-jMM-jDD "))}
                      <br />
                      {moment(item.date).format("ddd ")}
                    </p>
                  </div>
                  <div className="w-1/4 ps-6">
                    {digitsEnToFa(addCommas(item.price))}
                  </div>
                  <div className="w-1/4 flex justify-end">
                    <Icons
                      name="arrowLeft"
                      fill="none"
                      stroke="#1E1E1E"
                      size={40}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default ReportPenalty;
